__webpack_require__.p = "/upload-nova-charts/";